import { render, staticRenderFns } from "./FaqLine.vue?vue&type=template&id=485e03b6&scoped=true&"
import script from "./FaqLine.vue?vue&type=script&lang=js&"
export * from "./FaqLine.vue?vue&type=script&lang=js&"
import style0 from "./FaqLine.vue?vue&type=style&index=0&id=485e03b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e03b6",
  null
  
)

export default component.exports